/* checkValidation v1.0 */
(function($) { 
	$.fn.checkValidation = function(options) {
		var _this = this;
		var $this = $(this);
		var _isMobile = "ontouchstart" in window;
		var opt = $.extend({
			trigger: false,
			onlyBoolean: false
		}, options, $this.data());

		var form = {
			$fields: null,
			result: true,			
			radios: {},
			init: function(){
				if($this.is('input, textarea, select')) {
					form.$fields = $this;
				}else {
					form.$fields = $this.find('input, textarea, select');
				}
				form.validation();
			},
			accessibility: function(t, condition) {
				var $errorMsg = $(t).closest('.field-block').find(".error-msg"),
					errorId = $(t).attr('id') + 'Error'; 
				
				if ($errorMsg.length>0) {
					$errorMsg.find('> span').removeAttr('id');
					$(t).removeAttr('aria-describedby');

					if (!condition) {
						$errorMsg.find('> span').each(function() {
							if ($(this).is(':visible')) {
								$(this).attr('id', errorId);
								return false;
							}
						});
						$(t).attr('aria-describedby', errorId);
					}
				}
			},
			autoFocus: function(t){
				if(t.type.indexOf("select") >= 0 && $(t).is('.run-chosen')) {
					if(!$(t).is(':visible')) {
						$(t).trigger('chosen:activate');
					}else {
						$(t).focus();
					}
				}else {
					$(t).focus();
				}

				var $reTarget = $(t);
				if(t.type == 'radio') {
					check.$fieldBlock.addClass('error');					
					check.$errorMsg.find('.required').show();
					$reTarget = check.$fieldBlock.find('input[name="'+t.name+'"]');								
				}
				$reTarget.off('change.reconfirm').on({
					'change.reconfirm': function(e){
						var _field = e.currentTarget;
						form.validation(_field);

						$(_field).off('change.reconfirm');
					}
				});
			},
			validation: function(_targetField){
				var l,
					_fieldArray = [],
					errorFields = [];

				if(_targetField) {
					_fieldArray = [_targetField];
					//console.log("11111");
				}else {
					_fieldArray = form.$fields;
					//console.log("22222");
				}

				l = _fieldArray.length;
				//console.log("33333", l);

				// 20200409 START	오샘 || disable 항목 있을 시 error 동작하지 않는 버그 수정
				var tempBlock;
				// 20200409 END		오샘 || disable 항목 있을 시 error 동작하지 않는 버그 수정
				
				for (var i = 0; i < l; i++) {
					var t = _fieldArray[i];

					check.$fieldBlock = $(t).parents('.field-block');
					check.$errorMsg = check.$fieldBlock.find('.error-msg');

					// 20200406 START 전호근 || input:image 있을 경우 validation 넘어가는 오류 수정	
					// 20200311 START 김우람 || search 버튼 에러 메세지 오류 수정 
					if (t.type == 'image'){
						continue;
					}
					// 20200311 END 김우람 || search 버튼 에러 메세지 오류 수정 
					// 20200406 END 전호근 || input:image 있을 경우 validation 넘어가는 오류 수정
					// 20200316 START 김우람 || select 에러메세지 버그 수정
					if(!opt.onlyBoolean && $(t).hasClass('chosen-search-input') == false ) {
					// 20200316 END 김우람 || select 에러메세지 버그 수정
						// 200311 START 전호근 - 접근성 관련 수정
						$(t).removeAttr('aria-invalid');
						// 200311 END

						// 20200409 START	오샘 || disable 항목 있을 시 error 동작하지 않는 버그 수정
						
						if(tempBlock != check.$fieldBlock[0]){
							check.$fieldBlock.removeClass('error');
							check.$errorMsg.find('span').hide();
							//console.log("오샘1", check.$fieldBlock[0]);
						}
						
						
						
						tempBlock = check.$fieldBlock[0];
						// 20200409 END		오샘 || disable 항목 있을 시 error 동작하지 않는 버그 수정
					}

					var condition = true;
					var isMobile = $('header.navigation').is('.mobile-device');
					if($(t).is(":hidden") && t.type!="hidden"){
						var condition1 = t.type.indexOf("select") <= 0 && !$(t).is('.run-chosen'),
							condition2 = t.type.indexOf("select") <= 0 && $(t).siblings('.chosen-container').is(':hidden'),
							//모바일에서 chosen-container 없을경우 추가 
							condition3 = t.type.indexOf("select") <= 0 && isMobile;
							
						if(condition1 || condition2 || condition3 ) continue;
						// if is not select, skip this field;
					}else if($(t).is(":disabled")) {
						//console.log('disabled t', t);
						//console.log('disabled check.$fieldBlock', check.$fieldBlock);
						continue;
					}

					if(!check.required(t)) {// check required
						condition = false;
						
						if(!opt.onlyBoolean){							
							// 200311 START - 접근성 관련 수정
							$(t).attr('aria-invalid', true);
							// 200311 END
							//$(_this).find('.field-block').removeClass('error');
							check.$fieldBlock.addClass('error');
							form.accessibility(t, condition);
							//form.autoFocus(t);
						}
						//console.log('validation case 1');
						form.result = false;						

						errorFields.push(t);
						continue;
						//break;
					}else {
						// ie9 only
						if((t.type=="text" && t.getAttribute('data-type')) && (navigator.appVersion.indexOf("MSIE 9.")!=-1)) {
							t.setAttribute('type', t.getAttribute('data-type'));
						}
						// input condition validation
						// GPC0085 : textarea 케이스 추가
						var checkType = ['text', 'password', 'tel', 'email', 'number', 'textarea', 'file'];
						if(checkType.indexOf(t.type) >= 0) {
							// is text style input
							if(check.minLength(t)) {
								if(t.type == 'text') condition = check.pattern(t);
								if(t.type == 'email') condition = check.email(t);
								if(t.type == 'tel') condition = check.tel(t);
								if(t.type == 'file') condition = check.file(t);

								if(condition && t.getAttribute('data-match-target')) {
									condition = check.match(t);
								}
								// data-rule 속성 validation 추가
								if ( condition && t.getAttribute('data-rule') && $(t).val().length ){
									var dataRules = t.getAttribute('data-rule').split(',');
									var result = [];
									for (var ii=0,len = dataRules.length; ii < len ; ii++ ){
										// LGCOMIN-47 Start
										let b2bNumberDataRule = dataRules[ii];
										if(COUNTRY_CODE == 'in' && t.id == 'txtBoxBusinessNumber' && dataRules[ii] == 'number')
											b2bNumberDataRule = 'isText';
										// LGCOMIN-47 End

										result.push( check.dataRule[ b2bNumberDataRule ]( $(t) ) );

										if ( typeof result[result.length - 1] == 'string' ){
											condition = false;											
										}

										if ( result[result.length - 1] == false ){
											condition = false;											
										}
										//console.log('result', result);
										//console.log('result condition' , condition);
										//console.log('result condition t' , t);
									}
									//console.log( 'data rule error message code', result );
									//console.log('data rule error message code condition' , condition);
									//console.log('data rule error message code condition t' , t);
								}
							}else {
								condition = false;								
							}
						}else if(t.type == 'radio' || t.type == 'checkbox') {
							var selected = check.$fieldBlock.find('input[name="'+t.name+'"]:checked').get(0);
							// removed of unnecessary loops
							if(!form.radios[t.name] && selected) {
								form.radios[t.name] = {
									checkedField: selected
								};
								condition = check.radio(t);
							}else {
								continue;
							}							
						}
					}

					if(!condition) {						
						if(!opt.onlyBoolean) {
							// 200311 START 전호근 - 접근성 관련 수정
							$(t).attr('aria-invalid', true);
							// 200311 END
							check.$fieldBlock.addClass('error');
							form.accessibility(t, condition);
							//form.autoFocus(t);
						}
						//console.log('validation case 2');
						form.result = false;
						errorFields.push(t);
						continue;						
					}else {
						//form.result = true;
						// 20200316 START 김우람 || select 에러메세지 버그 수정
						if(!opt.onlyBoolean && $(t).hasClass('chosen-search-input') == false ) {
						// 20200316 END 김우람 || select 에러메세지 버그 수정
							// 200311 START 전호근 - 접근성 관련 수정
							$(t).removeAttr('aria-invalid');
							// 200311 END
							check.$fieldBlock.removeClass('error');
							form.accessibility(t, condition);
						}
					}
				}
				console.log('errorFields', errorFields);
				/*
				if (errorFields.length > 0){
					var firstInput = errorFields[0];
					$(t).parents('.field-block').addClass('error');
					check.$fieldBlock.find('.error-msg');
					form.autoFocus(errorFields[0]);
				}
				*/

				$.each(errorFields, function( idx ){
					//$(this).parents('.field-block').addClass('error');
					if (idx == 0){
						check.$fieldBlock = $(errorFields[0]).parents('.field-block');
						check.$errorMsg = check.$fieldBlock.find('.error-msg');
						form.autoFocus(errorFields[0]);
						//$(errorFields[0]).focus();
						console.log('errorFields[0]', errorFields[0]);
					}
				});
			}
		};
		var locale = $('html').data().countrycode;
		var check = {
			$fieldBlock: null,
			$errorMsg: null,
			required: function(t){
				var isEmpty,
					required = (t.getAttribute('required') != null) ? true : false;

				if($(t).is(":disabled")) required = false;
				if(t.type == 'checkbox' && (t.name == '' || t.name == undefined)) {
					isEmpty = !t.checked;
				}else if(t.type == 'radio' || (t.type == 'checkbox' && t.name)){
					var inputName = t.name;
					var $checkedField = check.$fieldBlock.find('input[name="'+inputName+'"]:checked');
					var checked = $checkedField.val();

					isEmpty = !checked ? true : false;
				}else {
					isEmpty = ($.trim($(t).val()) == "") || ($.trim($(t).val()) == null);
				}

				if(required && isEmpty) {// valiation error
					//console.log(t);

					if(!opt.onlyBoolean) check.$errorMsg.find('.required').show();
					if(opt.trigger) $(t).trigger('invalid.required');
					//console.log('check case 1');
					return false;
				} else {
					//console.log(t);
					// 20200316 START 김우람 || select 에러메세지 버그 수정
					if(!opt.onlyBoolean && $(t).hasClass('chosen-search-input') == false ) check.$errorMsg.find('.required').hide();
					// 20200316 END 김우람 || select 에러메세지 버그 수정
					if(opt.trigger) $(t).trigger('valid.required');
					return true;
				}
			},
			dataRule: {
				email: function(e) {
					var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
					if (locale == "/fr"){
						regex = /^[a-zA-Z0-9.!$%'*+=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
					}
					return regex.test( e.val() );
				},
				onlyAlphabet: function(a) {
					var b = /^[a-zA-Z]*$/;
					if (b.test(a.val()) || (!a.attr("required") && !a.is("[required]")) && (!a.val() || a.val() == a.attr("placeholder"))) {
						return true
					} else {
						check.$errorMsg.find('.required').show();
						return false;
						//return ("" + formerror["required"]).split("%title%").join(a.attr("title"))
					}
				},
				isText: function(a) {
					var b = /^[a-zA-Z0-9]*$/;
					if (b.test(a.val())) {
						return true;
					} else {
						check.$errorMsg.find('.required').show();
						return false;
						//return ("" + formerror["invalid"]).split("%title%").join(a.attr("title"))
					}
				},
				onlyCharacters: function(a) {
					var regexp = /^[0-9~`!@#$%^&*()_+-=]*$/;
					var regtemp = true;
					for (var i = 0; i < a.val().length; i++) {
						(regexp.test(a.val().charAt(i))) ? regtemp = false: null;
					}
					if (regtemp) {
						return true
					} else if (a.val() == "") {
						check.$errorMsg.find('.required').show();
						return false;
						//return ("" + formerror["required"]).split("%title%").join(a.attr("title"));
					} else {
						if (a.data('validmsg')) {
							//return a.data('validmsg');
							check.$errorMsg.find('.required').show();
							return false;
						} else {
							//return ("" + formerror["required"]).split("%title%").join(a.attr("title"));
							check.$errorMsg.find('.required').show();
							return false;
						}
		
					}
				},
				onlyCharactersBr: function(a) {
					var personType = a.closest("form").find("input[name='persontype']:radio:checked").val();
					var regexp = /^[0-9~`!@#$%^&*()_+,\-./:;<=>?[\\\]{|}'"]*$/;
					
					if (personType == "corporation") {
						regexp = /^[0-9~`!@#$%^&*()_+,.:;<=>?[\\\]{|}'"]*$/;
					}
					
					var regtemp = true;
					for (var i = 0; i < a.val().length; i++) {
						(regexp.test(a.val().charAt(i))) ? regtemp = false: null;
					}
					if (regtemp) {
						return true
					} else if (a.val() == "") {
						//return ("" + formerror["required"]).split("%title%").join(a.attr("title"));
						check.$errorMsg.find('.required').show();
						return false;						
					} else {
						if (a.data('validmsg')) {
						   if (personType == "corporation" && a.data('excepmsg')) {
								//return (a.data('validmsg') + " " + a.data('excepmsg'));
								check.$errorMsg.find('.required').show();
								return false;
							} else {
								check.$errorMsg.find('.required').show();
								return false;
								//return a.data('validmsg');
							}
						} else {
							//return ("" + formerror["required"]).split("%title%").join(a.attr("title"));
							check.$errorMsg.find('.required').show();
							return false;
						}
					} 
				},
				match: function(a, b) {
					if (a.val() != a.attr("placeholder") && a.val() == $('[name="' + b + '"]', a.closest("form")).val()) {
						return true
					} else {
						
						if (lgFilter.locale == "/jp" && a.hasClass("jpPassword")) {
							//return ("" + formerror["jpPwMatch"])
							check.$errorMsg.find('.required').show();
							return false;
						} else {
							check.$errorMsg.find('.required').show();
							return false;
							//return ("" + formerror["match"]).split("%title%").join(a.attr("title")).split("%target_title%").join($('[name="' + b + '"]').attr("title"))
						}
						
					}
				},
				minlength: function(a, b) {
					if (!a.val() || a.val() == a.attr("placeholder") || a.val().length >= b) {
						return true
					} else {
						if (a.data('validmsg')) {
							//return a.data('validmsg');
							check.$errorMsg.find('.required').show();
							return false;
						} else {
							if (locale == "jp" && a.attr("id") == "confirmPassword") {
								//return ("" + formerror["jpPwMin"]);
								check.$errorMsg.find('.required').show();
								return false;
							} else if(locale == "ru" && a.attr("id") == "contactPhone" && a.data("blurValidate")!==undefined ){
								//return (a.data("numberMsg"))
								check.$errorMsg.find('.required').show();
								return false;
							}else{
								//return ("" + formerror["minlength"]).split("%title%").join(a.attr("title")).split("%target%").join(b).split("%used%").join(a.val().length)
								check.$errorMsg.find('.required').show();
								return false;
							}
						}
					}
				},
				maxlength: function(a, b) {
					if (!a.val() || a.val() == a.attr("placeholder") || a.val().length <= b) {
						return true
					} else {
						return ("" + formerror["maxlength"]).split("%title%").join(a.attr("title")).split("%target%").join(b).split("%used%").join(a.val().length)
					}
				},
				textarea: function(e) {
					return e.val() && e.val() != e.attr("placeholder") ? !0 : ("" + formerror.required).split("%title%").join(e.attr("title"))
				},
				checkbox: function(e) {
					return e.prop("checked") || !e.attr("required") && !e.is("[required]") ? !0 : e.data("validmsg") ? e.data("validmsg") : ("" + formerror.checkbox).split("%title%").join(e.attr("title"))
				},
				radio: function(t) {
					return e('input[name="' + t.attr("name") + '"]:checked').val() || !t.attr("required") ? !0 : ("" + formerror.radio).split("%title%").join(t.attr("title"))
				},
				select: function(e) {
					return e.val() || !e.attr("required") && !e.is("[required]") ? !0 : ("" + formerror.required).split("%title%").join(e.attr("title"))
				},
				number: function(e) {
					var regex = /^\s*\d+\s*$/;
					if ( regex.test(e.val().replace(/-|\(|\)|\./g, '')) ) {
						if (locale == "vn" && e.attr("name") == "contactMobilePhone") {
							var n = 0;
							if (e.val().indexOf(0) == 0) {
								for (var r = 0; r < e.val().length; r++) {
									if (e.val()[r] != 0)
										break;
									n++
								}
								if (n == e.val().length)
									//return ("" + formerror.number).split("%title%").join(e.attr("title"))
									check.$errorMsg.find('.invalid').show();
									return false;
							}
							var i = e.val().substring(n, e.val().length);
							e.val(Number(i))
						}
						check.$errorMsg.find('.invalid').hide();
						return true;
					}
					check.$errorMsg.find('.invalid').show();
					return false;
				},
				noRepeatNum: function(a) {
					var c = '123456789012345678909876543210';
					var d = /^1{10}|2{10}|3{10}|4{10}|5{10}|6{10}|7{10}|8{10}|9{10}|0{10}$/;
					var _val = a.val().replace(/-|\(|\)|\./g, '');	// 20200409 김우람 || 정규식 수정
		
					if (c.indexOf(_val) < 0 && !d.test(_val)) {
						return true;
					} else {
						check.$errorMsg.find('.noRepeatNum').show();
						return false;
					}
				},
				date: function(e) {
					return e.val() || !e.attr("required") && !e.is("[required]") ? !0 : ("" + formerror.required).split("%title%").join(e.attr("title"))
				},
				required: function(t) {
					var n = e.trim(t.val());
					return n || !t.attr("required") && !t.is("[required]") || !t.find("option[value!='']").length && t[0].tagName == "SELECT" ? !0 : t.data("requiredSelectMsg") ? t.data("requiredSelectMsg") : ("" + formerror.required).split("%title%").join(t.attr("title"))
				},
				between: function(e, t) {
					var n = t.split("-");
					return !e.val() || e.val() == e.attr("placeholder") || e.val().length >= parseInt(n[0]) && e.val().length <= parseInt(n[1]) ? !0 : ("" + formerror.between).split("%title%").join(e.attr("title")).split("%target%").join(t)
				},
				incorrect: function(e) {
					return ("" + formerror.incorrect).split("%title%").join(e.attr("title"))
				},
				length: function(e, t) {
					return !e.val() || e.val() == e.attr("placeholder") || e.val().length == t ? !0 : ("" + formerror.length).split("%title%").join(e.attr("title")).split("%target%").join(t)
				},
				invalid: function(e) {
					return ("" + formerror.invalid).split("%title%").join(e.attr("title"))
				},
				already: function(e) {
					return "" + formerror.already
				},
				keywords: function(e, t) {
					return !e.val() || e.val() == e.attr("placeholder") || e.val().length >= t ? !0 : ("" + formerror.keywords).split("%title%").join(e.attr("title")).split("%target%").join(t)
				},
				newpassword: function(b) {
					if (b.val() && b.val() != b.attr("placeholder")) {
						var isValid = false;
						var char1 = /(abc)|(bcd)|(cde)|(def)|(efg)|(fgh)|(ghi)|(hij)|(ijk)|(jkl)|(klm)|(lmn)|(mno)|(nop)|(opq)|(pqr)|(qrs)|(rst)|(stu)|(tuv)|(uvw)|(vwx)|(wxy)|(xyz)|(qwer)|(wert)|(erty)|(rtyu)|(tyui)|(yuio)|(uiop)|(asdf)|(sdfg)|(dfgh)|(fghj)|(ghjk)|(hjkl)|(zxcv)|(xcvb)|(cvbn)|(vbnm)|(ABC)|(BCD)|(CDE)|(DEF)|(EFG)|(FGH)|(GHI)|(HIJ)|(IJK)|(JKL)|(KLM)|(LMN)|(MNO)|(NOP)|(OPQ)|(PQR)|(QRS)|(RST)|(STU)|(TUV)|(UVW)|(VWX)|(WXY)|(XYZ)|(QWER)|(WERT)|(ERTY)|(RTYU)|(TYUI)|(YUIO)|(UIOP)|(ASDF)|(SDFG)|(DFGH)|(FGHJ)|(GHJK)|(HJKL)|(ZXCV)|(XCVB)|(CVBN)|(VBNM)|(zyx)|(yxw)|(xwv)|(wvu)|(vut)|(uts)|(tsr)|(srq)|(rqp)|(qpo)|(pon)|(onm)|(nml)|(mlk)|(lkj)|(kji)|(jih)|(ihg)|(hgf)|(gfe)|(fed)|(edc)|(dcb)|(cba)|(poiu)|(oiuy)|(iuyt)|(uytr)|(ytre)|(trew)|(rewq)|(lkjh)|(kjhg)|(jhgf)|(hgfd)|(gfds)|(fdsa)|(mnbv)|(nbvc)|(bvcx)|(vcxz)|(ZYX)|(YXW)|(XWV)|(WVU)|(VUT)|(UTS)|(TSR)|(SRQ)|(RQP)|(QPO)|(PON)|(ONM)|(NML)|(MLK)|(LKJ)|(KJI)|(JIH)|(IHG)|(HGF)|(GFE)|(FED)|(EDC)|(DCB)|(CBA)|(POIU)|(OIUY)|(IUYT)|(UYTR)|(YTRE)|(TREW)|(REWQ)|(LKJH)|(KJHG)|(JHGF)|(HGFD)|(GFDS)|(FDSA)|(MNBV)|(NBVC)|(BVCX)|(VCXZ)|(012)|(123)|(234)|(345)|(456)|(567)|(678)|(789)|(890)|(987)|(876)|(765)|(654)|(432)|(321)|(210)/;
						var filter1 = /^[a-zA-Z]+$/;   
						var filter2 = /^[\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/;
						var filter3 = /^[0-9]+$/;
						var filter4 = /^[a-zA-Z\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/;
						var filter5 = /^[0-9\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/;
						var filter6 = /^[a-zA-Z0-9]+$/;
						var filter = /^[a-zA-Z0-9\~\!\@\#\$\%\^\&\*\(\)\_\-\+\|\{\}\[\]\,\.\/\?]+$/;
		
						if (char1.test(b.val())) {
							check.$errorMsg.find('.password3').show();
							return false;
						}
		
						if (b.val().length < 10) {
							if (filter1.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter2.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter3.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter4.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter5.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter6.test(b.val())) {
								check.$errorMsg.find('.password8').show();
								return false;
							}
							if (filter.test(b.val())) {
								if (b.val().length < 8) {
									check.$errorMsg.find('.password8').show();
									return false;
								} else {
									isValid = true;
								}
							}
		
							if (isValid == true) {
								return true;
							} else {
								check.$errorMsg.find('.notsymbols').show();
								return false;								
							}
						} else {
							if (filter1.test(b.val())) {
								check.$errorMsg.find('.password10').show();
								return false;
							}
							if (filter2.test(b.val())) {
								check.$errorMsg.find('.password10').show();
								return false;
							}
							if (filter3.test(b.val())) {
								check.$errorMsg.find('.password10').show();
								return false;
							}
							if (filter4.test(b.val())) {
								check.$errorMsg.find('.password10').show();
								return false;
							}
							if (filter5.test(b.val())) {
								check.$errorMsg.find('.password10').show();
								return false;
							}
							if (filter6.test(b.val())) {
								isValid = true;
							}
							if (filter.test(b.val())) {
								isValid = true;
							}
		
							if (isValid == true) {
								return true;
							} else {
								check.$errorMsg.find('.notsymbols').show();
								return false;
							}
						}
					}
				},
				// EMP 20220215 START 이상현 - emp password filter 추가
				newpasswordemp : function($input){
					var value = $input.val();
					var char1 = /(abc)|(bcd)|(cde)|(def)|(efg)|(fgh)|(ghi)|(hij)|(ijk)|(jkl)|(klm)|(lmn)|(mno)|(nop)|(opq)|(pqr)|(qrs)|(rst)|(stu)|(tuv)|(uvw)|(vwx)|(wxy)|(xyz)|(qwer)|(wert)|(erty)|(rtyu)|(tyui)|(yuio)|(uiop)|(asdf)|(sdfg)|(dfgh)|(fghj)|(ghjk)|(hjkl)|(zxcv)|(xcvb)|(cvbn)|(vbnm)|(ABC)|(BCD)|(CDE)|(DEF)|(EFG)|(FGH)|(GHI)|(HIJ)|(IJK)|(JKL)|(KLM)|(LMN)|(MNO)|(NOP)|(OPQ)|(PQR)|(QRS)|(RST)|(STU)|(TUV)|(UVW)|(VWX)|(WXY)|(XYZ)|(QWER)|(WERT)|(ERTY)|(RTYU)|(TYUI)|(YUIO)|(UIOP)|(ASDF)|(SDFG)|(DFGH)|(FGHJ)|(GHJK)|(HJKL)|(ZXCV)|(XCVB)|(CVBN)|(VBNM)|(zyx)|(yxw)|(xwv)|(wvu)|(vut)|(uts)|(tsr)|(srq)|(rqp)|(qpo)|(pon)|(onm)|(nml)|(mlk)|(lkj)|(kji)|(jih)|(ihg)|(hgf)|(gfe)|(fed)|(edc)|(dcb)|(cba)|(poiu)|(oiuy)|(iuyt)|(uytr)|(ytre)|(trew)|(rewq)|(lkjh)|(kjhg)|(jhgf)|(hgfd)|(gfds)|(fdsa)|(mnbv)|(nbvc)|(bvcx)|(vcxz)|(ZYX)|(YXW)|(XWV)|(WVU)|(VUT)|(UTS)|(TSR)|(SRQ)|(RQP)|(QPO)|(PON)|(ONM)|(NML)|(MLK)|(LKJ)|(KJI)|(JIH)|(IHG)|(HGF)|(GFE)|(FED)|(EDC)|(DCB)|(CBA)|(POIU)|(OIUY)|(IUYT)|(UYTR)|(YTRE)|(TREW)|(REWQ)|(LKJH)|(KJHG)|(JHGF)|(HGFD)|(GFDS)|(FDSA)|(MNBV)|(NBVC)|(BVCX)|(VCXZ)|(012)|(123)|(234)|(345)|(456)|(567)|(678)|(789)|(890)|(987)|(876)|(765)|(654)|(432)|(321)|(210)/;
					var filter = {
						combination : [
							/\d+/, 
							/[a-z]+/,
							/[A-Z]+/,
							/[\~\`\!\@\#\$\%\^\&\*\(\)\_\-\+\=\{\}\[\]\:\;\"\'\,\.\<\>\/\?\\\|]+/,
						],
						outOfRange : /[^0-9a-zA-Z\~\`\!\@\#\$\%\^\&\*\(\)\_\-\+\=\{\}\[\]\:\;\"\'\,\.\<\>\/\?\\\|]+/, // not ascii code and 1 ~ 32, 127 ~ 
						continueSame : /([\d\D])\1\1/,
					}
					var isValid = !filter.outOfRange.test(value);
					if (!isValid) {
						check.$errorMsg.find('.out-of-range').show();
						return false;
					}
					// inherit ["newpassword"]
					if (char1.test(value)) {
						check.$errorMsg.find('.password3').show();
						return false;
					}
					// new:emp case
					var passedComninationFlag = (function(){
						var count = 0;
						var isPassed = null;
						var array = filter.combination;
						for(var i=0; i<array.length; i++){
							array[i].test(value) && count++;
						}
						console.log("count :", count);
						isPassed = 3 <= count ? true : false;
						return !isPassed;
					})();
					if(passedComninationFlag){
						check.$errorMsg.find('.fail-to-combination').show();
						return false;
					}
					var isThreetimesAndMore = filter.continueSame.test(value);
					if(isThreetimesAndMore){
						check.$errorMsg.find('.continue-three-times').show();
						return false;
					}
					return isValid;
				},
				// EMP 20220215 END 이상현
				postcode: function(e) {
					var t = /^[a-zA-Z0-9]/;
					if ( t.test(e.val()) ){
						check.$errorMsg.find('.invalid').hide();
                        return true;
					} else {
						check.$errorMsg.find('.invalid').show();
						return false;
					}					
				},
				cpf: function(el) {
					var cpfNum = el.val().replace(/[^\d]/g, "");
					var numbers, modulus, multiplied, tmp, mod;
					var verifierDigit, sendErr;
		
					verifierDigit = function(numbers) {
						numbers = numbers.split("");
						modulus = numbers.length + 1;
						multiplied = [];
						tmp = 0;
		
						$.each(numbers, function(idx, number) {
							multiplied.push(parseInt(number, 10) * (modulus - idx));
						});
		
						$.each(multiplied, function(idx, number) {
							tmp += number;
						});
		
						mod = tmp % 11;
						return (mod < 2 ? 0 : 11 - mod);
					};
		
					sendErr = function() {
						check.$errorMsg.find('.invalid').show();
						return false;
					};
		
					numbers = cpfNum.substr(0, 9);
					numbers += verifierDigit(numbers);
					numbers += verifierDigit(numbers);
		
					if (cpfNum.length !== 11) {
						return sendErr();
					}
					if (numbers.substr(-2) !== cpfNum.substr(-2)) return sendErr();
		
					return true;
				},
				/* LGECL-174 add */
				rut: function(el) {
					var cpfNum = el.val().replace(/[^0-9kK]+/g, "");
					var numbers, sum, multiplo, mod, dv, rutNumbers;
					var verifierDigit, sendErr;
		
					verifierDigit = function(numbers) {
						numbers = numbers.toString().replace(/[^0-9kK]+/g, '').toUpperCase();
						sum = 0;
						multiplo = 2;
						
						for (i = 1; i <= numbers.length; i++) {
							index = multiplo * cpfNum.charAt(numbers.length - i);
							sum = sum + index;
						    if (multiplo < 7) {
							    multiplo = multiplo + 1;
						    } else {
						    	multiplo = 2;
						    }
						}
		
						mod = 11 - (sum % 11);
						
						dv = dv == "K" ? 10 :  dv;
						dv = dv == 0 ? 11: dv;
						return dv;
						
					};
		
					sendErr = function() {
						check.$errorMsg.find('.invalid').show();
						check.$errorMsg.show();
						return false;
					};
		
					numbers = cpfNum.slice(0, -1);
					dv = cpfNum.slice(-1).toUpperCase();
					
					rutNumbers = verifierDigit(numbers);
					
					var hasDuplicates = (/\b([0-9])\1\1\1\1\1\1\1+/).test(numbers);   
					if (cpfNum.length !== 9 || hasDuplicates) {
						return sendErr();
					}
					if (mod != rutNumbers) return sendErr();
		
					return true;
				},
				/* LGECL-174 End */
				cnpj: function(e) {
					var t = e.val().replace(/[^\d]/g, ""), n, r, i;
					return r = function(e) {
						var t = e.split(""), n = 2, r = 0, i = [], s, o, u, a;
						o = u = t.length;
						for (a = 0; a < o; a++)
							i.unshift(parseInt(t[a], 10));
						while (u--)
							r += parseInt(t[u], 10) * n,
							n = n === 9 ? 2 : n + 1;
						return s = r % 11,
						s < 2 ? 0 : 11 - s
					}
					,
					i = function() {
						//return ("" + formerror.invalid).split("%title%").join(e.attr("title"))
						check.$errorMsg.find('.invalid').show();
						return false;
					}
					,
					n = t.substr(0, 12),
					n += r(n),
					n += r(n),
					!t || t.length !== 14 ? i() : n.substr(-2) !== t.substr(-2) ? i() : !0
				},
				ukPostCheck: function(t) {
					if (!t.data("validCountryTarget")) {
						var form = t.parents('form');
						if ( $(form.get(0).countryCode).val() != "GB"){
							check.$errorMsg.find('.invalid').hide();
							return true;
						}
							
					} else {
						var n = $("[name=" + t.data("validCountryTarget") + "]").val();
						if (n != "GB"){
							check.$errorMsg.find('.invalid').hide();
							return true;
						}	
					}
					var r = /^[A-Za-z0-9]{1,4}\s{1}[A-Za-z0-9]{3}$/;
					if ( r.test(t.val()) ){
						check.$errorMsg.find('.invalid').hide();
						return true;
					} else {
						check.$errorMsg.find('.invalid').show();
						return false;
					}
				},
				nlPostCheck: function(t) {
					var n;
					if ( t.data("validCountryTarget") ){
						n = $("[name=" + t.data("validCountryTarget") + "]")[0];
					} else {
						var form = t.parents('form');
						n = form.get(0).countryCode;
					}
					    
					if (n.value == "BE" || n.value == 0) {
						var r = /^[1-9]{1}[0-9]{3}$/i;
						if ( r.test(t.val()) ){
							check.$errorMsg.find('.invalid').hide();
							return true;
						} else {
							check.$errorMsg.find('.invalid').text('Geldig Postcode is verplicht.').show();
							return "Geldig Postcode is verplicht.";
						}						
					}
					if (n.value == "NL") {
						var r = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
						if ( r.test(t.val()) ){
							check.$errorMsg.find('.invalid').hide();
							return true;
						} else {
							check.$errorMsg.find('.invalid').text('vul 4 cijfers gevolgd door een spatie en twee hoofdletters').show();
							return "vul 4 cijfers gevolgd door een spatie en twee hoofdletters";
						}
						
					}
				},
				caPostCheck: function(e) {
					var t = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i)
						, n = e.val().toString().trim();
					//return t.test(n.toString()) ? !0 : e.data("valid-rule-msg") ? e.data("valid-rule-msg") : ("" + formerror.required).split("%title%").join(e.attr("title"))
					if ( t.test(n.toString()) ){
						check.$errorMsg.find('.invalid').hide();
						return true;
					} else {
						check.$errorMsg.find('.invalid').show();
						return false;
					}
					
				},
				/* LGEPL-342 210316 add */
				plPostCheck: function(t) {
					var r = /^\d{2}-\d{3}$/;
					if ( r.test(t.val()) ){
						check.$errorMsg.find('.invalid').hide();
						return true;
					} else {
						check.$errorMsg.find('.invalid').show();
						return false;
					}
				},
				/*//LGEPL-342 210316 add */
				/*//LGEBE-44 210319 add */
				bePostCheck: function(t) {
					var n;
					if ( t.data("validCountryTarget") ){
						n = $("[name=" + t.data("validCountryTarget") + "]")[0];
					} else {
						var form = t.parents('form');
						n = form.get(0).countryCode;
					}
					    
					if (n.value == "BE") {
						var r = /\d{4}$/;
						if ( r.test(t.val()) ){
							check.$errorMsg.find('.invalid').hide();
							return true;
						} else {
							check.$errorMsg.find('.invalid').show();
							return false;
						}						
					}
					if (n.value == "LU") {
						var r = /^[L]{1}-\d{4}$/;
						if ( r.test(t.val()) ){
							check.$errorMsg.find('.invalid').hide();
							return true;
						} else {
							check.$errorMsg.find('.invalid').show();
							return false;
						}
					}
				},
				/*//LGETH-216 210319 add */
				pcCodeCheck: function(t) {
					var r = /^[A-Za-z0-9]+$/;
					if ( r.test(t.val()) ){
						check.$errorMsg.find('.invalid').hide();
						return true;
					} else {
						check.$errorMsg.find('.invalid').show();
						return false;
					}
				},
				/*//LGEBE-44 210319 add */
				imei: function(t) {
					var n = /^[0-9]{15}$/;
					var r = $("input[name=checkIMEI]");

					if (!n.test(t.val())){
						return r.val("N");
					} else {
						return true;
					}						
					var i = 0
						, s = 2
						, o = 14;
					for (var u = 0; u < o; u++) {
						var a = t.val().substring(o - u - 1, o - u)
							, f = parseInt(a, 10) * s;
						f >= 10 ? i += f % 10 + 1 : i += f,
						s == 1 ? s++ : s--
					}
					var l = (10 - i % 10) % 10;
					return l != parseInt(t.val().substring(14, 15), 10) ? (r.val("N"),
					!0) : (r.val("Y"),
					!0)
				},
				huMobile: function(e) {
					var t = /^[0-9|\+0-9]+$/;
					return e.val() == "+36" ? ("" + formerror.huMobile).split("%title%").join(e.attr("title")) : t.test(e.val()) ? !0 : ("" + formerror.huMobile).split("%title%").join(e.attr("title"))
				},
				receipt: function(e) {
					var t = /^(CN|RN)+([A-Za-z0-9]{0,14}?)$/
						, n = /^[0-9]{15}$/;
					return !t.test(e.val().toUpperCase()) && !n.test(e.val().toUpperCase()) ? ("" + formerror.invalid).split("%title%").join(e.attr("title")) : !0
				},
				brForgotPW: function(t) {
					var n = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/
						, r = /^\s*\d+\s*$/
						, i = t.closest("form").find("input[name=cpfFlag]");
					if (n.test(t.val()) || !t.attr("required") && !t.is("[required]") && (!t.val() || t.val() == t.attr("placeholder")))
						return i.val("N"),
						!0;
					if (!n.test(t.val())) {
						var s = t.val().replace(/[^\d]/g, ""), o, u, a, f, l, c, h;
						return c = function(t) {
							return t = t.split(""),
							u = t.length + 1,
							a = [],
							f = 0,
							e.each(t, function(e, t) {
								a.push(parseInt(t, 10) * (u - e))
							}),
							e.each(a, function(e, t) {
								f += t
							}),
							l = f % 11,
							l < 2 ? 0 : 11 - l
						}
						,
						h = function() {
							return ("" + formerror.invalid).split("%title%").join(t.attr("title"))
						}
						,
						o = s.substr(0, 9),
						o += c(o),
						o += c(o),
						s.length !== 11 ? h() : o.substr(-2) !== s.substr(-2) ? h() : (i.val("Y"),
						!0)
					}
					return ("" + formerror.invalid).split("%title%").join(t.attr("title"))
				},
				emailCaptcha: function(t) {
					var n = t.closest(".validateForm")
						, r = "";
					if (t.closest(".validateForm").hasClass("addCaptchaEmail"))
						return e.ajax({
							url: n.attr("data-captcha-url"),
							type: n.attr("method"),
							async: !1,
							data: {
								LBD_VCID_customizedCaptcha: e("input[name=LBD_VCID_customizedCaptcha]").val(),
								getInstanceId: e("input[name=getInstanceId]").val(),
								getCodeCollection: e("input[name=getCodeCollection]").val(),
								captchaCodeTextBox: e("input[name=captchaCodeTextBox]").val()
							},
							dataType: "json",
							beforeSend: function() {
								n.addClass("process")
							},
							success: function(e) {
								e.result ? n.addClass("success") : e.error && (n.removeClass("success"),
								r = e.error.captchaCodeTextBox)
							},
							complete: function(e) {
								n.removeClass("process")
							}
						}),
						n.hasClass("success") ? !0 : (e("#customizedCaptcha_ReloadLink").trigger("click"),
						"" + r)
				},
				keywordCheck: function(t) {
					var n = $("input[name=keyword]");
					return n.val() == null ? ("" + formerror.required).split("%title%").join(t.attr("title")) : n.val() != t.val() ? ("" + formerror.required).split("%title%").join(t.attr("title")) : !0
				},
				ukSerialNumber: function(e) {
					if (locale == "ca_en" || locale == "ca_fr") {
						var t = new Date;
						t = t.getFullYear() % 10;
						var n = e.val()[0];
						if (isNaN(n) == 0)
							if (t - n > -3 && t - n < 0 || t - n > 7){
								//return e.nextAll(".msg-error").css("z-index", "20");
								if(!opt.onlyBoolean) {
									check.$errorMsg.find('.invalid_ca').length ? check.$errorMsg.find('.invalid_ca').show() : check.$errorMsg.find('.invalid').show();
								}
								if(opt.trigger) $(t).trigger('invalid.invalid');
								return false;
							}
					}
					/* LGEUK-324 Start */
					if (e.attr("ismobile") == "Y")
						var r = /^([0-9]{14})([0-9 ]{0,2})$/;
					else if (e.attr("ismobile") == "N" || e.attr("ismobile") == undefined)
						var r = /^(\d{3})([A-Za-z]{4})([A-Za-z0-9]{5})([A-Za-z0-9]{0,4})$/; // LGEUK-324
					/* LGEUK-324 End */
					if (r.test(e.val().toUpperCase())) {
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').hide();
						if(opt.trigger) $(t).trigger('valid.invalid');
						return true;
					} else { 
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
						if(opt.trigger) $(t).trigger('invalid.invalid');
						return false;
					}
					// return r.test(e.val().toUpperCase()) ? !0 : false; //("" + formerror.ukSerialNumber).split("%title%").join(e.attr("title"))
				}
			},
			pattern: function(t){
				var pattern = t.getAttribute('pattern') ? t.getAttribute('pattern') : t.getAttribute('data-pattern');

				if (pattern && t.value != '') {
					pattern = (pattern == "\\d*") ? "^[0-9]*$" : pattern; // zip code only

					var val = t.value;
					var regex = new RegExp(pattern,"i");

					if(!regex.test(val)) {
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
						if(opt.trigger) $(t).trigger('invalid.pattern');
						//console.log('check case 2');
						return false;
					}else {
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').hide();
						return true;
					}
				} else if (t.getAttribute('data-date-format') && t.value != '') {
					var formatArray = t.getAttribute('data-date-format').split('/');
					var regex ="";
					for (var i = 0,len = formatArray.length;i < len; i++){
						if ( formatArray[i] == 'mm'){
							regex += '(0[1-9]|1[012])';
						}

						if ( formatArray[i] == 'dd'){
							regex += '(0[1-9]|[12][0-9]|3[01])';
						}

						if ( formatArray[i] == 'yy' || formatArray[i] == 'yyyy'){
							regex += '(19|20)\\d\\d';
						}

						if ( i !== len - 1){
							regex += '/';
						}
					}
					//console.log('date format regex', regex);

					if ( new RegExp(regex).test(t.value) ){
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').hide();
						return true;
					} else {
						if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
						if(opt.trigger) $(t).trigger('invalid.pattern');
						return false;
					}


				} else return true;
				
				
			},
			// maxLength: function(t){
			// 	var max = t.getAttribute('data-max');
			// 	if(max) {
			// 		var length = t.value.length;
			// 		if(length > max) {// valiation error
			// 			// trigger invalid
			// 			if(opt.trigger) $(t).trigger('invalid.max');
			// 			return false;
			// 		}
			// 	}
			// 	else return true;
			// },
			minLength: function(t){
				var min = t.getAttribute('minLength');

				if(min) {
					var length = t.value.length;
					if(length < min && length > 0) {// valiation error
						// trigger invalid
						if(!opt.onlyBoolean) check.$errorMsg.find('.min-length').show();
						if(opt.trigger) $(t).trigger('invalid.min');
						return false;
					}else {
						if(!opt.onlyBoolean) check.$errorMsg.find('.min-length').hide();
						return true;
					}
				}
				else return true;
			},
			email: function(t){
				var val = t.value;
				var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

				if(!regex.test(val) && $.trim(val)) {
					if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
					if(opt.trigger) $(t).trigger('invalid.email');
					return false;
				}else {
					if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').hide();
					return true;
				}
			},
			tel: function(t){
				var val = t.value;
				// var regex = new RegExp(/^[+]?[0-9]{9,12}$/);
				var regex = new RegExp(/^[0-9]*$/);
				if(!regex.test(val)) {
					if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
					if(opt.trigger) $(t).trigger('invalid.tel');
					return false;
				}else {
					if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').hide();
					return true;
				}
			},
			match: function(t){
				// match check;
				if(t.value != $(t.getAttribute('data-match-target')).val()) {
					// console.log(check.$errorMsg);
					if(!opt.onlyBoolean) check.$errorMsg.find('.match').show();
					return false;
				}else {
					if(!opt.onlyBoolean) check.$errorMsg.find('.match').hide();
					return true;
				}
			},
			radio: function(t){
				var _selected = form.radios[t.name].checkedField,
					_related = _selected.getAttribute('data-related-input');
				if(_related && $(_related).val() == '') { // is it related text input was empty?
					var _$relatedBlock = $(_related).parent('.field-block');
					if(!opt.onlyBoolean) {
						_$relatedBlock.find('.error-msg .required').show();
						$(_related).focus();
					}
					return false;
				}else {
					return true;
				}
			},
			file: function(t){
				if(!t.files[0]) return true;
				
				// check file size
				var maxSize = $(t).data('max'),
					extension = $(t).data('extension'), // 허용되는 파일 확장자 목록, |로 구분 되어 있음 
					filesize = 0,
					browser = navigator.appName,
					file = $(t).get(),
					ext,
					fileExtension,
					//LGCOMCS-90 START
					videoUseFlag = $(t).data('video-use-flag') || 'N',
					videoMaxSize = $(t).data('max-video') || 0,
					videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'hevc', 'wmv'],
					fileInputs = document.getElementsByClassName('fileupload'),
					allFiles = [],
					videoCount = 0;
					//LGCOMCS-90 END
				
				if (!maxSize && !extension) return true;

				if (maxSize.indexOf('MB')!=-1) {
					maxSize = parseInt(maxSize.split('MB')[0])*1024*1024;
				}
				if (window.FileReader){
					fileSize = $(t)[0].files[0].size;
					ext = $(t)[0].files[0].name;
				} else {
					var fileobj = new ActiveXObject("Scripting.FileSystemObject");
					fileSize = fileobj.getFile( file.value ).size;
					ext = $(t).val().split('/').pop().split('\\').pop();
				}
				
				//LGCOMCS-90 START
				// Check file extension
				fileExtension = ext.split('.')[ext.split('.').length-1].toLowerCase();
				
				if($.inArray(fileExtension, extension.split('|')) == -1) {
					if(!opt.onlyBoolean) check.$errorMsg.find('.invalid').show();
					if(opt.trigger) $(t).trigger('invalid.file');
					return false;
				}
				
				if(videoUseFlag == 'Y'){
					if (videoMaxSize.indexOf('MB')!=-1) {
						videoMaxSize = parseInt(videoMaxSize.split('MB')[0])*1024*1024;
					}
					
					if (videoExtensions.includes(fileExtension)) {	//비디오 파일인 경우
						if(fileSize > videoMaxSize){
							if(!opt.onlyBoolean) check.$errorMsg.find('.size').show();
							if(opt.trigger) $(t).trigger('invalid.file');
							return false;
						}
						
						for (var i = 0; i < fileInputs.length; i++) {
					        var input = fileInputs[i];
					        if (input.files && input.files.length > 0) {
					            allFiles.push(input.files[0]);
					        }
					    }

					    for (var j = 0; j < allFiles.length; j++) {
					        var videoFile = allFiles[j];
					        var videoFileName = videoFile.name;
					        var videoExt = videoFileName.substring(videoFileName.lastIndexOf('.') + 1).toLowerCase();

					        if (videoExtensions.includes(videoExt)) {
					            videoCount++;
					        }
					    }
						
						if(videoCount > 1){
							if(!opt.onlyBoolean) check.$errorMsg.find('.videoCount').show();
							if(opt.trigger) $(t).trigger('invalid.file');
							return false;
						}
					}else{	//이미지 파일인 경우
						if (fileSize > maxSize) {
							if(!opt.onlyBoolean) check.$errorMsg.find('.size').show();
							if(opt.trigger) $(t).trigger('invalid.file');
							return false;
						}
					}
				}else{
					// Check file size
					if (fileSize > maxSize) {
						if(!opt.onlyBoolean) check.$errorMsg.find('.size').show();
						if(opt.trigger) $(t).trigger('invalid.file');
						return false;
					}
				}
				//LGCOMCS-90 END

				if(opt.trigger) $(t).trigger('valid.file');
				return true;
			}
		};

		

		this.each(function() {
			form.init();
		});

		return form.result;
	};
})(jQuery);

$(document).ready(function(){
	$('input[type="radio"], input[type="checkbox"]').on({
		change: function(e){
			var _this = e.currentTarget,
				_target = _this.getAttribute('data-related-input')
				$block = $(_this).parents('.field-block');

			// LGCOMUS-246
			
			// 200311 START 전호근 - 접근성 관련 수정 
			//$block.removeClass('error');
			// 200311 END 전호근

			if(_this.checked) {
				//$block.find('input[type="text"]').attr('disabled','disabled');
				
				$block.find('[data-related-input]').each(function() {
					$($(this).data('relatedInput')).attr('disabled', true).removeAttr('required');
				});
				
				
				if(_target) {
					$(_target).attr('disabled', false).attr('required','required').eq(0).focus();
				}
				
			}else {
				$(_target).attr('disabled',true).removeAttr('required');
			}
		}
	});
	$('.auto-validation-form').on({
		submit: function(e){
			// e.preventDefault();
			$('body').trigger('ajaxLoadBefore');
			var $this = $(this);
			if(!$this.checkValidation()){
				e.preventDefault();
				$this.trigger('validationFail', [this]); // validation result event trigger
				$('body').trigger('ajaxLoadEnd');
			}else {
				// console.log('submit!');
				$this.trigger('validationSuccess', [this]); // validation result event trigger
				$('body').trigger('ajaxLoadEnd');
			}
		}
	});

	// LGEEG-190 Start
	// *********************************************************
	// 모바일 입력 UX 향상을 위해 type tel을 number 변경하려 하였으나,
	// maxlength 기능 X + FF/IE 크로스브라우징 X + 하이픈(-) 입력됨
	// => type=tel 유지 + number only 기능 개선
	// *********************************************************
	// data-oninput="~" 존재 : 실시간 입력 rule check = Y
	// data-oninput="number" : rule = number only
	$('input[type="tel"]').on('input', function(e){
		var onInput = $(this).data('oninput') ? $(this).data('oninput') : ''; // 실시간 입력 rule check 여부 + data null check
		if (onInput == 'number') {
			$(this).val( $(this).val().replace(/[^0-9]/gi,"") );
		}
	});
	// LGEEG-190 End
});